var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.open
      ? _c(
          "div",
          {
            staticClass: "button dark",
            class: _vm.$style.close,
            on: { click: _vm.close },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("visibility_off"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Exit Selection")]),
          ]
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.open,
            expression: "open",
          },
        ],
        class: _vm.$style.main,
        style: _vm.fullStyle,
      },
      [
        _c("color-picker", {
          attrs: {
            value: _vm.color,
            classes: _vm.colorActive ? _vm.$style.active : "",
            label: "Solid Color",
          },
          on: { input: _vm.setColor },
        }),
        _c("div", { class: _vm.$style.flipped }, [
          _c(
            "div",
            { class: _vm.$style.samples },
            _vm._l(_vm.sampleImages, function (sample, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: {
                    [_vm.$style.sample]: true,
                    [_vm.$style.active]: _vm.activeImage(sample),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setImage(sample)
                    },
                  },
                },
                [
                  _c("img", {
                    class: _vm.$style.img,
                    attrs: { src: sample, alt: "Sample Background Image" },
                  }),
                ]
              )
            }),
            0
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }